var NavPaneContentComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./nav-pane-content.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./nav-pane-content.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, ViewContainerRef } from "@angular/core";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { DashboardRoutingConstants } from "../../dashboard/dashboard-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { NavConstants } from "../nav.constants";
import { AppControllerService } from "../../../app-controller.service";
import { MapRoutingConstants } from "../../../map/map-routing.constants";
import { Router } from "@angular/router";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { SettingRoutingConstants } from "../../settings/setting-routing.constants";
import { ToolsLinkMap } from "../../tools/shared/tool-link-map.model";
import { ToolsHeadingEnum } from "../../tools/shared/tools-heading-models";
import { RolesEnum } from "../../organisations/shared/models/organisation-heading-enum";
import { OrganisationRoutingConstants } from "../../organisations/organisation-settings-routing.constants";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { AlertType } from "../../../shared/models/alert";
import { SystemModuleSettingsService } from "../../../shared/services/system-module-settings.service";
import { aflaModuleServiceProvider } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service.provider";
import { StrategyFinderComponent } from "../../../shared/components/strategy-finder/strategy-finder.component";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { AppConfig } from "src/app/app.config";
let NavPaneContentComponent = class NavPaneContentComponent {
    static { NavPaneContentComponent_1 = this; }
    userInformationService;
    appControllerService;
    authService;
    router;
    systemModuleSettingsService;
    viewContainerRef;
    appConfig;
    items = ['First', 'Second', 'Third'];
    logoSrc = NavConstants.LOGO_SOURCE;
    modulesLink = AppRoutingConstants.ROUTE_SEPERATOR + DashboardRoutingConstants.MODULES_ROUTE;
    homeLinkText = NavConstants.HOME_LINK_TEXT;
    logoutLinkText = NavConstants.LOGOUT_LINK_TEXT;
    settingsLinkText = NavConstants.SETTINGS_LINK_TEXT;
    applyToOrganisationLinkText = NavConstants.APPLY_TO_ORGANISATION_LINK_TEXT;
    focusElement;
    settingsName;
    aflaSettingsName = NavConstants.AFLA_SETTINGS_TEXT;
    isSystemAdmin = false;
    addOrganisationLink;
    addMobileConfigLink;
    toolsMapLinks = new Array();
    adminLinks = new Array();
    $userOrganisations;
    userOrganisations = [];
    organisationId;
    menuMode = "modules";
    activeId = "";
    moduleSuspended;
    selectedModuleID;
    hideHomeText = false;
    $isAuthenticated;
    $systemModuleSettingsFetched;
    systemModuleLinks;
    adminModules;
    orgSuspendedText = NavConstants.ORGANISATION_SUSPENDED_TEXT;
    moduleSuspendedText = NavConstants.MODULE_SUSPENDED_TEXT;
    addModuleLink;
    displayOrgSettings = false;
    authenticatedUser;
    menuModeOptions = {
        moduleSettings: "moduleSettings",
        moduleTools: "moduleTools",
        orgSettings: "orgSettings",
        aflaSettings: "aflaSettings"
    };
    aflaSettingsItems = {
        organisations: "Organisations",
        mobileConfig: "Mobile configuration"
    };
    authenticatedUserSubscription;
    userOrganisationsSubscription;
    adminUserOrganisationsSubscription;
    allowedUserOrganisations;
    systemModulesSubscription;
    adminModulesSubscription;
    settingsSubscription;
    constructor(userInformationService, appControllerService, authService, router, systemModuleSettingsService, viewContainerRef, appConfig) {
        this.userInformationService = userInformationService;
        this.appControllerService = appControllerService;
        this.authService = authService;
        this.router = router;
        this.systemModuleSettingsService = systemModuleSettingsService;
        this.viewContainerRef = viewContainerRef;
        this.appConfig = appConfig;
        this.listenForSystemModules();
        this.$systemModuleSettingsFetched = this.systemModuleSettingsService.$systemModuleSettingsFetched;
        this.settingsSubscription = this.appConfig.$settings.subscribe(settings => {
            if (settings !== null) {
                AppConfig.settings = settings;
                this.logoSrc = AppConfig.settings.municipalData.aflalogo;
                this.hideHomeText = AppConfig.settings.projectSettings.hideHomeText;
            }
        });
    }
    static buildSettingsAddress(routeName) {
        return AppRoutingConstants.createRouteToView(SettingRoutingConstants.SETTINGS_ROUTE, routeName.toLocaleString().trim().toLocaleLowerCase());
    }
    ngOnInit() {
        this.listenForAuthentication();
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.subscribe(user => {
            this.isSystemAdmin = user.isSysAdmin;
            this.authenticatedUser = user;
            const organisations = user.organisations
                .sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1));
            this.appControllerService.organisationsSubject.next(organisations);
            this.$userOrganisations = this.appControllerService.$organisationsSubject;
            this.userOrganisations = organisations;
        });
        // this.showSettingsForOrganisationAdmin();
        this.mapToolsLinksList();
        this.buildAddLinks();
        this.showDefaultModule();
    }
    logout() {
        this.authService.logOutRedirect();
    }
    settings() {
    }
    selectModule(link, organisation) {
        this.appControllerService.selectedOrganisationID(organisation.id);
        const orgModule = organisation.modules.find(module => module.id === link.data);
        if (orgModule.suspended) {
            this.appControllerService.showMessage(this.moduleSuspendedText, AlertType.Warning);
            return;
        }
        this.appControllerService.setSelectedModule(link.data);
        // need to route to Refresh Component to force reload ApplicationsComponent
        // this.router.navigate([AppRoutingConstants.ROUTE_SEPERATOR + link.text]);
        // this.router.navigate([
        //   AppRoutingConstants.ROUTE_SEPERATOR +
        //   this.appControllerService.selectedModuleID +
        //   AppRoutingConstants.ROUTE_SEPERATOR +
        //   ApplicationsRoutingConstants.APPLICATIONS_ROUTE
        // ]);
        this.router.navigate([
            AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.REFRESH_ROUTE
        ]);
    }
    showMap() {
        this.router.navigate([AppRoutingConstants.ROUTE_SEPERATOR + MapRoutingConstants.ESRI_MAP_ROUTE]);
    }
    applyToOrganisation() {
        this.router.navigate([AppRoutingConstants.ROUTE_SEPERATOR + AppRoutingConstants.ORGANISATION_APPLY_ACCESS_ROUTE]);
    }
    toggleAccordian(event) {
        // If it is already open you will close it and if it is closed open it
        this.activeId = this.activeId === event ? "" : event;
    }
    trackSystemModuleLink(index, item) {
        return item.data;
    }
    setLinksWithModule(address) {
        return AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(this.selectedModuleID, address);
    }
    showSettingsForModule(link, organisationName, moduleElementRef) {
        const organisationId = moduleElementRef.getAttribute("data-message-id");
        this.appControllerService.selectedOrganisationID(+organisationId);
        this.appControllerService.setSelectedModule(link.data);
        this.settingsName = `${organisationName} - ${link.address} settings`;
        this.menuMode = this.menuModeOptions.moduleSettings;
        this.selectedModuleID = link.data;
    }
    showToolsForModule(link, organisationName, moduleElementRef) {
        const organisationId = moduleElementRef.getAttribute("data-message-id");
        this.appControllerService.selectedOrganisationID(+organisationId);
        this.appControllerService.setSelectedModule(link.data);
        this.settingsName = `${organisationName} - ${link.address} tools`;
        this.menuMode = this.menuModeOptions.moduleTools;
        this.selectedModuleID = link.data;
    }
    showOrganisationMenuItems(organisation) {
        this.organisationId = organisation.id;
        this.settingsName = ` ${organisation.name} - settings`;
        this.displayOrgSettings = true;
        this.menuMode = this.menuModeOptions.orgSettings;
    }
    showAflaSettings() {
        this.menuMode = this.menuModeOptions.aflaSettings;
    }
    displaySuspendedMessage(organisation) {
        const userHasRoles = this.authenticatedUser.organisations.find(org => org.id === organisation.id)?.userSystemRoles;
        if (organisation.suspended || userHasRoles?.length === 0) {
            this.appControllerService.showMessage(this.orgSuspendedText, AlertType.Warning);
        }
    }
    isOrganisationSuspended(organisation) {
        const orgSuspended = "organisation-suspended";
        const userHasRoles = this.authenticatedUser.organisations.find(org => org.id === organisation.id)?.userSystemRoles;
        return (organisation.suspended || userHasRoles?.length === 0) ? orgSuspended : "";
    }
    isModuleSuspended(currentModule, organisation) {
        let displayModule = "";
        const orgSuspended = "module-suspended";
        this.moduleSuspended = false;
        const orgModule = organisation.modules.find(module => module.id === currentModule.data);
        if (orgModule.suspended) {
            this.moduleSuspended = true;
            displayModule = orgSuspended;
        }
        return displayModule;
    }
    isOrganisationAdmin(organisation) {
        let displayOrgSettings = false;
        if (this.isSystemAdmin) {
            return true;
        }
        this.userOrganisationsSubscription = this.$userOrganisations.subscribe(organisations => {
            const org = organisations.find(userOrganisation => userOrganisation.id === organisation.id);
            if (org) {
                org.userSystemRoles?.some(userSystemRole => {
                    if ((userSystemRole.role === RolesEnum.OrganisationAdmin || userSystemRole.role === RolesEnum.SuperAdmin)
                        && !organisation.suspended) {
                        displayOrgSettings = true;
                    }
                });
            }
        });
        return displayOrgSettings;
    }
    canShowTools(link, organisation) {
        let canShow = false;
        if (JSON.stringify(this.focusElement) === JSON.stringify(link)) {
            canShow = true;
        }
        return canShow;
    }
    canShowSettings(link, organisation) {
        let moduleAdmin = false;
        const modules = organisation.modules;
        if (JSON.stringify(this.focusElement) === JSON.stringify(link)) {
            const foundModule = modules.find(module => module.id === link.data);
            if (foundModule) {
                moduleAdmin = foundModule?.userModuleRoles?.some(role => role.role === RolesEnum.ModuleAdmin);
            }
        }
        return moduleAdmin;
    }
    isAdmin(link, organisationId) {
        let moduleAdmin = false;
        if (JSON.stringify(this.focusElement) === JSON.stringify(link)) {
            this.adminUserOrganisationsSubscription = this.$userOrganisations.subscribe(organisations => {
                const organisation = organisations.find(userOrganisation => userOrganisation.id === organisationId);
                if (organisation) {
                    organisation.userSystemRoles.some(userSystemRole => {
                        if (userSystemRole.role === RolesEnum.OrganisationAdmin ||
                            userSystemRole.role === RolesEnum.SuperAdmin || this.isSystemAdmin) {
                            moduleAdmin = true;
                        }
                    });
                }
            });
        }
        return moduleAdmin;
    }
    goBackToModules() {
        this.menuMode = "modules";
        // this.settingsVisible = false;
        // this.toolsMapVisible = false;
        // this.organisationSettingsVisible = false;
        this.displayOrgSettings = false;
    }
    allowedToViewModules(link) {
        let isAllowed = true;
        const linkText = "Modules";
        const orgId = this.organisationId;
        if (link.text.toLowerCase() === linkText.toLowerCase()) {
            this.allowedUserOrganisations = this.$userOrganisations.subscribe(organisations => {
                const organisation = organisations.find(userOrganisation => userOrganisation.id === orgId);
                if (organisation) {
                    organisation.userSystemRoles.some(userSystemRole => {
                        isAllowed = userSystemRole.role === RolesEnum.SuperAdmin || this.isSystemAdmin;
                        return isAllowed;
                    });
                }
            });
        }
        return isAllowed;
    }
    listenForSystemModules() {
        this.systemModuleLinks = new Array();
        this.systemModulesSubscription = this.userInformationService.$systemModules.subscribe(items => {
            const links = new Array();
            items.forEach(item => {
                const link = AppRoutingConstants.ROUTE_SEPERATOR +
                    ApplicationsRoutingConstants.APPLICATIONS_ROUTE +
                    AppRoutingConstants.ROUTE_SEPERATOR +
                    item.id;
                links.push({ text: link, address: item.name, data: item.id });
            });
            this.systemModuleLinks = links;
        });
        this.adminModulesSubscription = this.userInformationService.$adminModules.subscribe(items => {
            this.adminModules = items;
        });
    }
    mapToolsLinksList() {
        this.toolsMapLinks = new Array();
        Object.keys(ToolsHeadingEnum).forEach((toolsHeading) => {
            this.toolsMapLinks.push({
                // @ts-ignore
                text: ToolsHeadingEnum[toolsHeading],
                // @ts-ignore
                address: AppRoutingConstants.createRouteToViewWithPrefixRouteSeparator(ToolsLinkMap.get(ToolsHeadingEnum[toolsHeading]))
            });
        });
    }
    buildAddLinks() {
        this.addOrganisationLink = {
            text: NavConstants.MANAGE_ORGANISATION_LINK_TEXT,
            address: AppRoutingConstants
                .createRouteToViewWithPrefixRouteSeparator(AppRoutingConstants.ORGANISATION_CONFIG_ROUTE)
        };
        this.addModuleLink = {
            text: NavConstants.ADD_MODULE_LINK_TEXT,
            address: AppRoutingConstants
                .createRouteToViewWithPrefixRouteSeparator(OrganisationRoutingConstants.ORGANISATION_SETTINGS_ROUTE, OrganisationRoutingConstants.MODULES_ROUTE)
        };
        this.addMobileConfigLink = {
            text: NavConstants.MANAGE_MOBILE_CONFIG_LINK_TEXT,
            address: AppRoutingConstants
                .createRouteToViewWithPrefixRouteSeparator(AppRoutingConstants.MOBILE_CONFIG_ROUTE)
        };
    }
    showDefaultModule() {
        // function will show all modules by default if user has only 1 organisation assigned
        const activePanel = "panel-0";
        this.userOrganisationsSubscription = this.$userOrganisations.subscribe(value => {
            if (value.length === 1) {
                this.activeId = activePanel;
            }
        });
    }
    listenForAuthentication() {
        this.$isAuthenticated = this.authService.$isAuthenticated;
    }
    getSettingLinks() {
        const componentRef = this.viewContainerRef.createComponent(StrategyFinderComponent);
        const strategy = componentRef.instance.moduleStrategyService;
        const settingLinks = new Array();
        Object.keys(strategy.settingsMenuHeadings).forEach((settingHeading) => {
            settingLinks.push({
                // @ts-ignore
                text: strategy.settingsMenuHeadings[settingHeading].replace("Afla", "AFLA"),
                address: NavPaneContentComponent_1.buildSettingsAddress(strategy.settingsMenuHeadings[settingHeading])
            });
        });
        componentRef.destroy();
        return settingLinks.sort((a, b) => 0 - (a.address.toLowerCase() > b.address.toLowerCase() ? -1 : 1));
    }
    settingsLinkClicked(header) {
        this.appControllerService.selectedSettingsHeader(header);
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: AppControllerService },
        { type: AuthService },
        { type: Router },
        { type: SystemModuleSettingsService },
        { type: ViewContainerRef },
        { type: AppConfig }
    ];
};
NavPaneContentComponent = NavPaneContentComponent_1 = __decorate([
    Component({
        selector: "app-nav-pane-content",
        providers: [aflaModuleServiceProvider],
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], NavPaneContentComponent);
export { NavPaneContentComponent };
